const screenWidth = {
  computed: {
    lg() {
      return window.screen.width >= 1024;
    },
  },
};

export default screenWidth;
